
import { defineComponent, reactive, toRefs, nextTick, onMounted,ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  deviceLists,
  adddevicess,
  deleteDevices,
  editDevices,
  getForproducers,
  deviceSnlists,
  venderAndDeviceTypeslist
} from "@/apis/group";
import { ElMessage } from "element-plus";
import { stat } from "fs";
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      tableDatatiming: [],
      todisbinfalge: false,
      shebeimingcheng: "",
      shebeibianma: "",
      changshangid:"",
      shebeixinghao: "",
      rfidbianqian: "",
      pleasecsmzy: "",
      pleasecsmdzy: "",
      pleasecsidsbxh:'',
      setconfim: "",
      deletecompanyfalge: false,
      deletedetail: null,
      formInline: {
          companyId: "",
          page: 1,
          pageSize: 100,
          sn: "",
      },
      robotList:[],
      shebeilist:[],
      value1: ref([]),
      value2: ref([]),
      vulue:ref([]),
      options:ref([]),
      defultoption:[],
      weiyiid:null
    });
    const method = reactive({
      fn1(row:any, column:any, cell:any, event:any) {
       console.log(column,row)
      },
      gowarehouse(index: number, row: any) {
        router.push({
          name: "warehouseRecord",
          params: {
            sn: row.sn,
          },
        });
      },
      handleChange(vals:any){
        state.changshangid = vals[0]
        state.shebeixinghao = vals[1]
        console.log(state.vulue)
      },
      setchangsha(val:any) {
         console.log(val)
         state.formInline.companyId = String(val)
         method.getdevlistrs()
      },
       setshebisn(val:any) {
         console.log(val)
         state.formInline.sn = val
         method.getdevlistrs()
      },
      godisinfetcrecord(index: number, row: any) {
        router.push({
          name: "disinfectionRecord",
          params: {
            sn: row.sn,
          },
        });
      },
      setdisbin(index: number, rows: any) {
        state.setconfim = "set";
        console.log(index, rows);
        state.changshangid = rows.companyNameId;
        state.shebeimingcheng = rows.deviceName;
        state.shebeibianma = rows.sn;
        state.shebeixinghao = rows.deviceTypeId;
        state.rfidbianqian = rows.rfid;
        let abc:any = [parseInt(state.changshangid),parseInt(state.shebeixinghao)]
        state.vulue = abc
        state.todisbinfalge = true;
        state.weiyiid = rows.id
        console.log(state.vulue)
      },
      removebin(index: number, rows: any) {
        console.log(index, rows);
        state.deletedetail = rows;
        state.deletecompanyfalge = true;
      },
      canceltingflage() {
        state.deletecompanyfalge = false;
      },
      detelechangshang(elsa: any) {
        deleteDevices({
          sn: elsa.sn,
          deletedBy: 0,
        }).then((resdea: any) => {
          console.log(resdea);
          if (resdea.code === 200) {
            method.getdevlistrs();
            state.deletecompanyfalge = false;
          }
        });
      },
      newtodisbin() {
        state.setconfim = "add";
        state.todisbinfalge = true;
      },
      canceltodis() {
        state.todisbinfalge = false;
        state.options = []
        nextTick(() => {
          state.pleasecsmzy = "";
          state.pleasecsmdzy = "";
          state.pleasecsidsbxh = "";
          state.shebeimingcheng = ''
          state.shebeibianma = "";
          state.changshangid = "";
          state.shebeixinghao = "";
          state.rfidbianqian = "";
          state.vulue = []
          state.options = state.defultoption
          state.weiyiid = null
        });
      },
      getdevlistrs() {
        deviceLists(state.formInline).then((res: any) => {
          console.log(res);
          state.tableDatatiming = res.data.deviceVOList;
        });
      },
      Shutdowntodis() {
        if (state.shebeimingcheng === "") {
          state.pleasecsmzy = "请输入设备名称";
          state.pleasecsmdzy = "";
          state.pleasecsidsbxh = "";
        } else if (state.shebeibianma === "") {
          state.pleasecsmdzy = "请输入设备编码";
          state.pleasecsmzy = "";
          state.pleasecsidsbxh = "";
        } else if (state.changshangid === ""||state.shebeixinghao ==="") {
          state.pleasecsidsbxh = "请输入设备型号&产商";
          state.pleasecsmzy = "";
          state.pleasecsmdzy = "";
        } else {
          if (state.setconfim === "set") {
            console.log("我是设置");
            editDevices({
              companyNameId: state.changshangid,
              deviceName: state.shebeimingcheng,
              deviceTypeId: state.shebeixinghao,
              rfid: state.rfidbianqian,
              sn: state.shebeibianma,
              id: state.weiyiid
            }).then((editres: any) => {
              console.log(editres);
              if (editres.code === 200) {
                ElMessage({
                  message: "编辑设备成功",
                  type: "success",
                });
                method.getdevlistrs();
                state.options = []
                nextTick(() => {
                  state.pleasecsmzy = "";
                  state.pleasecsmdzy = "";
                  state.pleasecsidsbxh = "";
                  state.shebeimingcheng = "";
                  state.shebeibianma = "";
                  state.changshangid = "";
                  state.shebeixinghao = "";
                  state.rfidbianqian = "";
                  state.options = state.defultoption
                  state.vulue = []
                  state.weiyiid = null
                });
                state.todisbinfalge = false;
              } else {
                ElMessage({
                  message: editres.msg,
                });
              }
            });
          } else {
            console.log("我是新增");
            adddevicess({
              companyNameId: state.changshangid,
              deviceName: state.shebeimingcheng,
              deviceTypeId: state.shebeixinghao,
              rfid: state.rfidbianqian,
              sn: state.shebeibianma,
            }).then((ress: any) => {
              console.log(ress);
              if (ress.code === 200) {
                ElMessage({
                  message: "新增设备成功",
                  type: "success",
                });
                method.getdevlistrs();
                state.options = []
                nextTick(() => {
                state.pleasecsmzy = "";
                state.pleasecsmdzy = "";
                state.pleasecsidsbxh = ""; 
                state.shebeimingcheng = "";
                state.shebeibianma = "";
                state.changshangid = "";
                state.shebeixinghao = "";
                state.rfidbianqian = "";
                state.options = state.defultoption
                state.vulue = []
              });
              state.todisbinfalge = false;
              }
            });
          }
        }
      },
    });
    onMounted(() => {
      method.getdevlistrs();
      getForproducers({}).then((ducerreq:any)=>{
        console.log(ducerreq)
        state.robotList = ducerreq.data.companyList
      })
      deviceSnlists({}).then((devisnreqq:any)=>{
        console.log(devisnreqq)
        state.shebeilist = devisnreqq.data
      })
      venderAndDeviceTypeslist({}).then((adndeviereq:any)=>{
        console.log(adndeviereq)
        if (adndeviereq.code === 200) {
          let list = adndeviereq.data
          let arr:any = []
						list.map((item:any, index:number) => {
							let obj = {
								label: item.companyName,
								value: item.companyId,
								children: []
							}
							arr.push(obj)
							let data = item.deviceTypeList
							if (data && data.length > 0) {
								data.map((li:any) => {
									let _obj = {
										label: li.name,
										value: li.id,
									}
									arr[index].children.push(_obj)
								})
							}
						})
						state.options = arr
            state.defultoption = arr
        }
      })
    });
    return {
      ...toRefs(state),
      ...toRefs(method),
    };
  },
});
